function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.986 12.016c.019 2.937.019 4.412 0 4.426-5.67 3.176-11 3.176-15.986 0V12",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.067 6.762L1.053 11.41l11.874 4.852 12.039-5.172-11.899-4.33zM.871 11.482l-.103.039-.078-.117.076-.11.105.043v.144zm24.246-.456l.136-.058.053.08-.091.134-.103-.037.005-.119z",
  stroke: "#371447",
  fill: "#9575CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.658 19.223h-.807V14.73c.012-.075.014-.124.004-.148a1.022 1.022 0 00-.224-.177l-5.384-2.853.37-.737 5.413 2.867.014.01c.234.149.396.289.492.444.111.177.145.392.122.638v4.449z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.152 10.411)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.561 7.445)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.823.938l.41.303C.461 2.346.34 3.598.873 5.027l-.47.186C-.19 3.626-.052 2.19.822.938zM1.974.92l.505.044c-.118 1.684.369 2.569 1.462 2.768l-.083.51C2.47 3.989 1.84 2.845 1.974.921z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.23 1.336l.456.224c-.52 1.119-.44 2.179.24 3.216l-.419.29c-.78-1.19-.873-2.444-.276-3.73z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.67 1.04l.492.12c-.364 1.623-.108 2.608.727 3.035l-.222.464c-1.088-.556-1.408-1.789-.998-3.62z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  strokeWidth: 0.562,
  cx: 1.605,
  cy: 0.915,
  r: 1
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.245,
  cy: 0.811,
  rx: 2.244,
  ry: 1
})));

function SvgEducationSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEducationSm;